<template>
  <div class="prediction-detail-container">
    <div class="prediction-header">
      <div class="prediction-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#5b6ef5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
        </svg>
      </div>
      <div class="prediction-title-section">
        <h1 class="prediction-title">{{ prediction.title }}</h1>
        
      </div>
    </div>
    <div class="predictions-indicators">
      <div class="prediction-percentage-label">{{ prediction.percentage }}% - текущий прогноз</div>
      <div class="prediction-details-row">
        <div class="detail-item">
          <label>Объем:  {{ prediction.volume }}</label>
        </div>
        <div class="detail-item">
          <label>Заявок: {{ prediction.ordersCount }}</label>
          <span></span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PredictionDetail',
  props: {
    prediction: {
      type: Object,
      required: true
    }
  },
  emits: ['vote'],
  setup(props, { emit }) {
    return {
      emit
    };
  }
};
</script>

<style scoped>
.prediction-detail-container {
  /* padding: 1.5rem 0; */

}

.prediction-header {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.2rem;
  align-items: center;
}

.prediction-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.prediction-icon svg {
  width: 100%;
  height: 100%;
  opacity: 0.8;
}

.prediction-title-section {
  flex: 1;
  min-width: 0;
}

.prediction-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
  margin: 0 0 0.5rem 0;
}


.predictions-indicators{
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap:1rem;
    padding-top: 1.5rem;
  }

.prediction-details-row {
    display: flex;
    gap: 2rem;
    flex-wrap: nowrap;
    overflow-x: clip;
}

.detail-item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.detail-item label {
  font-weight: 600;
  color: #6b7280;
  font-size: 0.875rem;
}

.detail-item span {
  font-size: 1.25rem;
  color: #1f2937;
  font-weight: 500;
}

.prediction-actions {
  display: flex;
  gap: 1rem;
}

.action-btn {
  flex: 1;
  padding: 1rem 1.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f9fafb;
  color: #1f2937;
}

.action-btn.yes {
  border-color: #10b981;
  color: #10b981;
  background-color: #ecfdf5;
}

.action-btn.yes:hover {
  background-color: #d1fae5;
  border-color: #059669;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.action-btn.no {
  border-color: #ef4444;
  color: #ef4444;
  background-color: #fef2f2;
}

.action-btn.no:hover {
  background-color: #fecaca;
  border-color: #dc2626;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}
</style>